export const MaximumNumberOfTabs=99;